import { Epic, ofType } from 'redux-observable';
import { EpicDependencies } from '@ui/store/rootEpic';
import * as actions from '../actions';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

export const loadStores: Epic<any, any, any, EpicDependencies> = (
  action$,
  store,
  { storeApi },
) =>
  action$.pipe(
    ofType(actions.STORES_ACTIONS.REQUESTED),
    switchMap(({ region: { city: { id } } }) =>
      storeApi.getStoresByCityId(id).pipe(
        switchMap(({ stores }) => of(actions.storesSucceeded(stores))),
        catchError(error => of(actions.storesSucceeded(error))),
      ),
    ),
  );



// WEBPACK FOOTER //
// ./src/scenes/Stores/services/epics/loadStores.ts